import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import loteService from '../../services/loteService';
import loteInformesService from '../../services/loteInformesService';
import type { LoteTrazabilidad } from '../../types/lotes-informes';
import { getApiErrorMessage } from '../../utils/apiError';

const LotesTrazabilidadInforme: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [codigoArticulo, setCodigoArticulo] = useState('');
  const [nroLote, setNroLote] = useState('');
  const [data, setData] = useState<LoteTrazabilidad | null>(null);

  const buscar = async () => {
    try {
      const list = await loteService.search({ codigoArticulo, nroLote, pageSize: 1 });
      if (!list.items[0]) {
        enqueueSnackbar('Lote no encontrado', { variant: 'warning' });
        setData(null);
        return;
      }
      setData(await loteInformesService.trazabilidad(list.items[0].idLote));
    } catch (err) {
      enqueueSnackbar(getApiErrorMessage(err, 'Error al consultar trazabilidad'), { variant: 'error' });
    }
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <Card sx={{ bgcolor: '#fff', borderRadius: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <CardContent>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: '#1976d2', mb: 2 }}>
            Trazabilidad / recall de lotes
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 2 }}>
            <TextField size="small" label="Artículo" value={codigoArticulo} onChange={(e) => setCodigoArticulo(e.target.value)} />
            <TextField size="small" label="Nro lote" value={nroLote} onChange={(e) => setNroLote(e.target.value)} />
            <Button variant="contained" startIcon={<SearchIcon />} onClick={buscar}>Buscar</Button>
          </Stack>

          {data && (
            <>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Lote {data.lote.nroLote} — {data.lote.codigoArticulo}
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Cliente</TableCell>
                    <TableCell>Teléfono</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Comprobante</TableCell>
                    <TableCell>Fecha</TableCell>
                    <TableCell align="right">Cant. neta</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.ventas.map((v) => (
                    <TableRow key={`${v.nroIDFormulario}-${v.nroCliente}`}>
                      <TableCell>{v.nroCliente} — {v.nombreCliente}</TableCell>
                      <TableCell>{v.telefono || '—'}</TableCell>
                      <TableCell>{v.email || '—'}</TableCell>
                      <TableCell>{v.letra}-{v.nroSuc}-{v.nroComprobante}</TableCell>
                      <TableCell>{v.fecha ? String(v.fecha).slice(0, 10) : '—'}</TableCell>
                      <TableCell align="right">{v.cantidadNeta}</TableCell>
                    </TableRow>
                  ))}
                  {data.ventas.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={6}>Sin ventas para recall</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default LotesTrazabilidadInforme;
